import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ComboGroupRecords, ComboRecord } from '../../../_models/front/combox/ComboRecord';

@Component({
  selector: 'grouping-combox',
  template: `
<div class="dropdown {{DivCss}}" [class.disabled]="!Enabled" 
 clickOutside
  (clickOutside)="isOpen && onComboxOpenedClickOutside()"
>
  <button
    type="button"
    class="trigger"
    (click)="toggle()"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
  >
    <span *ngIf="CbSelection; else placeholder" class="span-selection">

       <i *ngIf="CbSelection?.Icon" class="{{ CbSelection?.Icon }}" title ={{CbSelection?.IconTooltip}}></i>  
        {{ CbSelection?.Label }}
    </span>
    <ng-template #placeholder>
      {{InputStatePlaceHolder}}
    </ng-template>
     <span class="k-icon k-i-caret-alt-down k-i-ddl-down"></span>
  </button>
  <div class="menu" *ngIf="isOpen" role="listbox">
    <div class="search-box">
        <kendo-textbox
                  [(ngModel)]="searchTermModel"
                  [clearButton]="true"
                  [placeholder]="searchPlaceHolder"
                  class="search-textbox"> 
                  <!-- Icône de recherche -->
                  <ng-template kendoTextBoxPrefixTemplate>
                    <span class="k-icon k-i-search k-icon-search" title="{{iconSearchTooltip}}"></span>
                  </ng-template>             
          </kendo-textbox>
    </div>
    <ng-container *ngFor="let group of filteredReferentials">
      <div class="group-label">{{ group.Label }}</div>
      <div
        class="item"
        *ngFor="let option of group.Records"
        (click)="onSelection(option)"
        role="option"
        [class.selected]="CbSelection && option.Id === CbSelection?.Id"
      >
         <i *ngIf="option?.Icon" class="{{ option?.Icon }}"  title ={{option?.IconTooltip}}></i>
          <span>{{ option.Label }}</span>
      </div>
    </ng-container>
  </div> 
</div>
`,
  styleUrls: ['./groupCombox.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,

})

/**Component d'une liste parametrable et groupable */
export class GroupComboxComponent implements OnInit {

  /**Valeurs completes referentiel */
  private _referentials!: ComboGroupRecords[];
  @Input()
  set Referentials(_iReferentials: ComboGroupRecords[]) {
    this._referentials = _iReferentials;

    if (!this.CbSelection)
      if (_iReferentials?.length) {
        _iReferentials.forEach((fGrp: ComboGroupRecords) => {
          if (fGrp?.Records?.length > 0) {
            if (fGrp.Records.find(t => t && t.Preselected == true)) {
              //attribue celui préselectionné (favoris)
              this.CbSelection = fGrp.Records.filter(t => t && t.Preselected == true)[0];
            }
          }
        }
        )
      }
  }


  /**Liste d'enregistrement référentiel affiché conditionnée au filtre */
  get filteredReferentials() {
    if (!this.searchTermModel) {
      return this._referentials;
    }
    const term = this.searchTermModel.toLowerCase();
    return this._referentials?.map((group: ComboGroupRecords) => ({
      ...group,
      Records: group.Records.filter((record: ComboRecord) =>
        record.SearchTerms.toLowerCase().includes(term)
      )
    }))
      .filter((group: any) => group.Records.length > 0);
  }

  /**si l'input est ouvert */
  public isOpen = false;

  //texte affichéde recherche
  public searchPlaceHolder: string = "Rechercher ...";
  // texte recherché client
  public searchTermModel: string | null = null;

  /**Texte tooltip sur icone de recherche */
  @Input()
  iconSearchTooltip: string = "";


  //texte affiché sur l'input indique la donnée
  //si pas de sélection et chargement terminé
  @Input() placeHolders: string | undefined;

  //texte affiché durant le chargement si null affichera "Chargement ..."
  @Input() loadingText: string | null = null;

  //si la combox est dispo
  @Input() Enabled: boolean = false;

  /**le référentiel est en cours de chargement */
  @Input() IsRefLoading: boolean = true;


  /**div loader in progress */
  public get DivCss() {
    if (this.IsRefLoading == true) {
      return "loadingInProgress"
    }
    else return "";
  }

  /**Texte affiché dans l'input selon l'état en chargement */
  public get InputStatePlaceHolder() {
    if (this.IsRefLoading == true) {
      return this.loadingText != null ? this.loadingText : " Chargement ... "
    } else return this.placeHolders;
  }


  //la donnée user selected
  @Input() CbSelection: ComboRecord | null = null;

  /**Event propagation selection*/
  @Output() dataChange = new EventEmitter();

  constructor() {
  }

  ngOnInit() {

  }

  //sur event
  toggle() {

    this.isOpen = !this.isOpen;
  }

  /**sur selection d'un enregistrement */
  onSelection(selection: ComboRecord) {
    this.CbSelection = selection
    this.isOpen = false;
    this.dataChange.emit(selection);
  }

  /**
   * Event sur click hors de la combobox que celle ci est ouverte, provoque sa fermeture
   */
  public onComboxOpenedClickOutside() {
    if (this.isOpen) {
      this.isOpen = false;
    }
  }

}
